<template>
    <section>
        <div v-if="loading">
            <!-- BTN -->
            <div class="my-5">
                <form>
                    <input type="file" class="hidden" id="file" @change="onFileChange"
                        accept="image/png, image/jpeg">
                    <div class="text-left" v-if="loadImage">
                        <strong><i class="fa fa-spinner fa-spin"></i> Cargando...</strong>
                    </div>
                    <label for="file" class="button bg-theme-7 text-white button-sm" v-else>
                        <i class="fa fa-photo"></i> Cambiar Foto
                    </label>
                </form>
            </div>
            <!-- END: BTN -->
        </div>

        <app-loading v-else />
    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
    name: 'AdminProfile',
    props: ['user'],
    data() {
        return {
            loadImage: false,
            loading: false,
            file: null,
        }
    },
    computed: {
    },
    beforeMount() {
        this.loading = true
    },
    methods: {
        async changeAvatar() {
            var vm = this
            vm.loading = true

            const formData = new FormData()
            formData.append('id', vm.user.id)
            formData.append('entity', 'user')
            formData.append('image', this.file)

            await vm.store(formData).then(user => {
                vm.loadImage = false
                window.location.reload()
            })
                .catch(message => {
                    console.log('error', message)
                    vm.loadImage = false
                })
        },
        onFileChange(e) {
            console.log('onfile')
            this.loadImage = true
            var files = e.target.files || e.dataTransfer.files
            if (!files.length) {
                return
            }
            var file = files[0]
            this.file = e.target.files[0]
            this.changeAvatar()
        },
        ...mapActions([
            'show',
            'store'
        ])
    },
    components: {
        appLoading: Loading
    }
}
</script>



// WEBPACK FOOTER //
// EditPhoto.vue?11379ff4